import { useLocation } from '@direct-frontend/modules-router';
import { isForceDesktopSearch } from './forceDesktop';
import { resolveEffectivePlatform } from './resolveEffectivePlatform';
import { type DevicePlatform } from './types';
import { getDevicePlatform } from './windowPlatform';

export const useEffectivePlatform = (): DevicePlatform => {
    const { pathname, search } = useLocation();
    const devicePlatform = getDevicePlatform();

    return resolveEffectivePlatform({
        devicePlatform,
        pathname,
        forceDesktop: isForceDesktopSearch(search),
    });
};
